import { compile as compilePathPattern } from "path-to-regexp";
import qs from "qs";

import { isObject } from "@/utils/language";

export function composeUrl(
  url: string,
  ...composers: ((url: string) => string)[]
) {
  return composers.reduce((acc, composer) => composer(acc), url);
}

export function hasParams(
  urlConfig: unknown
): urlConfig is { params: unknown } {
  return (
    // eslint-disable-next-line no-prototype-builtins
    isObject(urlConfig) && urlConfig.hasOwnProperty("params")
  );
}

export function hasQuery(urlConfig: unknown): urlConfig is { query: unknown } {
  return (
    // eslint-disable-next-line no-prototype-builtins
    isObject(urlConfig) && urlConfig.hasOwnProperty("query")
  );
}

export function withParams(params: Record<string, unknown> | null) {
  return (path: string) =>
    params
      ? compilePathPattern(path, { encode: encodeURIComponent })(params)
      : path;
}

export function withQuery(query: Record<string, unknown> | null) {
  return (path: string) =>
    query
      ? `${path}?${qs.stringify(query, {
          arrayFormat: "comma",
        })}`
      : path;
}
